import { render } from "./scoreContent.vue?vue&type=template&id=534882e8&scoped=true"
import script from "./scoreContent.vue?vue&type=script&lang=js"
export * from "./scoreContent.vue?vue&type=script&lang=js"

import "./scoreContent.vue?vue&type=style&index=0&id=534882e8&scoped=true&lang=less"

import exportComponent from "/dev/shm/repo/piano-dp60u5626l1a/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-534882e8"]])

export default __exports__